export default __webpack_public_path__ + "static/media/_DSC0391.e02cf628.JPG";